module.exports = __webpack_public_path__ + "img/UsersGroupRounded1.86f16c6d.svg";